var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"secondary-market-orders-view-container",attrs:{"fluid":""}},[_c('h1',[_vm._v("Secondary Market Orders")]),_vm._v(" "),_c('secondary-market-orders-table',{attrs:{"secondary-market-orders":_vm.secondaryMarketOrders,"secondary-market-orders-pagination":_vm.pagination,"loading":_vm.loading}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92438560","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/baader/SecondaryMarketOrders.vue
// module id = null
// module chunks = 